import clsx from "clsx";
import { Br } from "@/components/molecules/Br";

export const SpeedCmsIntro = ({ className }) => {
  return (
    <>
      <div
        className={clsx(
          className,
          "mx-auto box-border flex max-w-7xl items-center md:grid-cols-2 md:gap-10 md:pt-8 md:pb-10"
        )}
      >
        <h3 className="w-full font-serif font-bold text-pri fluid-text-[18px,32px]">
          シンプル･オールインワンの基本機能+強力な拡張性。
          <Br tbpc />
          速くて、軽くて、ちょうどいい。動作環境を問わない高速軽快高機能CMS。
        </h3>
      </div>
    </>
  );
};
